export const StickySidebar = {
  mounted() {
    const stickyElement = this.el;
    const startPosition = stickyElement.getBoundingClientRect().top;

    let endScroll = window.innerHeight - stickyElement.offsetHeight - 500;
    let currPos = window.scrollY;
    let screenHeight = window.innerHeight;
    let stickyElementHeight = stickyElement.offsetHeight;
    let topGap = 0;
    let bottomGap = 0;

    setTimeout(() => {
      if (stickyElement.hasAttribute(`data-top-gap`)) {
        const dataTopGap = stickyElement.getAttribute(`data-top-gap`);
        topGap = String(dataTopGap) == 'auto' ? startPosition : parseInt(dataTopGap);
      } else if (stickyElement.hasAttribute('data-top-gap-element-selector')) {
        const topGapElementSelector = stickyElement.getAttribute('data-top-gap-element-selector');
        if (document.querySelector(topGapElementSelector)) {
          topGap = document.querySelector(topGapElementSelector).offsetHeight;
        }
      }
      if (stickyElement.hasAttribute(`data-bottom-gap`)) {
        bottomGap = parseInt(stickyElement.getAttribute(`data-bottom-gap`));
      } else if (stickyElement.hasAttribute('data-bottom-gap-element-selector')) {
        const bottomGapElementSelector = stickyElement.getAttribute(
          'data-bottom-gap-element-selector'
        );
        if (document.querySelector(bottomGapElementSelector)) {
          bottomGap = document.querySelector(bottomGapElementSelector).offsetHeight;
        }
      }
    }, 100);

    stickyElement.style.position = `sticky`;
    stickyElement.style.top = topGap + `px`;
    stickyElement.style.height = 'fit-content';

    function positionStickySidebar() {
      endScroll = window.innerHeight - stickyElement.offsetHeight - bottomGap;
      const stickyElementTop = parseInt(stickyElement.style.top.replace(`px;`, ``));
      if (stickyElementHeight + topGap + bottomGap > screenHeight) {
        if (window.scrollY < currPos) {
          if (stickyElementTop < topGap) {
            stickyElement.style.top = stickyElementTop + currPos - window.scrollY + `px`;
          } else if (stickyElementTop >= topGap && stickyElementTop != topGap) {
            stickyElement.style.top = topGap + `px`;
          }
        } else {
          if (stickyElementTop > endScroll) {
            stickyElement.style.top = stickyElementTop + currPos - window.scrollY + `px`;
          } else if (stickyElementTop < endScroll && stickyElementTop != endScroll) {
            stickyElement.style.top = endScroll + `px`;
          }
        }
      } else {
        stickyElement.style.top = topGap + `px`;
      }
      currPos = window.scrollY;
    }
    function updateSticky() {
      screenHeight = window.innerHeight;
      stickyElementHeight = stickyElement.offsetHeight;
      positionStickySidebar();
    }
    setTimeout(() => {
      window.addEventListener(`resize`, () => {
        currPos = window.scrollY;
        updateSticky();
      });
      document.addEventListener(`scroll`, updateSticky, {
        capture: true,
        passive: true
      });
    }, 200);
  }
};
